<app-header></app-header>
<div #parentContainer class="parentOfChatWindow">
  <div class="chat_window">
    <div>
      <app-chat-messages-display
       [messages]="messages" [referenceNumberInMsg]="referenceNumber"
        (actionDispatched)="changeActionInput($event)" (restartProcess)="callNgOnInitAgain()">
      </app-chat-messages-display>
    </div>
  </div>
</div>

<div class="chatInputAndButton">
  <app-chat-input [action]="actionToTake" (sendMessage)="sendMessageFromInput($event)"
    (readyToAnswerOrNot)="handleReadyOrNot($event)"></app-chat-input>
</div>

